import { useToastStore, type ToastVariant } from '../stores/toast'

export function useToast() {
  const addToast = useToastStore((s) => s.addToast)

  return {
    toast: (title: string, options?: { description?: string; variant?: ToastVariant }) =>
      addToast({ title, ...options, variant: options?.variant ?? 'info' }),
    success: (title: string, description?: string) =>
      addToast({ title, description, variant: 'success' }),
    error: (title: string, description?: string) =>
      addToast({ title, description, variant: 'error' }),
    warning: (title: string, description?: string) =>
      addToast({ title, description, variant: 'warning' }),
    info: (title: string, description?: string) =>
      addToast({ title, description, variant: 'info' }),
  }
}
